import { createTheme } from "@material-ui/core/styles";

const outerTheme = createTheme({
	typography: {
		allVariants: {
			fontFamily: "Tahoma",
		}
	},
	palette: {
		primary: {
			main: "#306989" // new logo the gray background 
		},
		secondary: {
			main: "#2f4858",
		},
	},
	overrides: {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		MuiButton: {

			root: {
				textTransform: "none",

			},
		},
		MuiTab: {
			root: {
				textTransform: "none",
			}
		},
		MuiCard: {
			root: {
				overflow: "initial"
			}
		}
	},
	props: {
		MuiButton: {
			disableElevation: true
		},
		MuiTable: {

		}
	}
});

export default outerTheme;
